import http from '@/shared/api/http'

const base = (jobId, revisionId) => `/import-jobs/${jobId}/column-mapping-revisions/${revisionId}/excel-product-type-drafts`

export async function listExcelProductTypeDrafts(jobId, revisionId, afterItemOrder = -1) {
  return (await http.get(base(jobId, revisionId), { params: { afterItemOrder, pageSize: 25 } })).data
}
export async function listCompactExcelProductTypeDrafts(jobId, revisionId, afterItemOrder = -1) {
  return (await http.get(`${base(jobId, revisionId)}/compact`, { params: { afterItemOrder, pageSize: 25 } })).data
}
export async function getExcelProductTypeDraft(jobId, revisionId, draftId) {
  return (await http.get(`${base(jobId, revisionId)}/${draftId}`)).data
}
export async function getExcelProductTypeTransitionMetadata(jobId, revisionId, draftIds) {
  return (await http.post(`${base(jobId, revisionId)}/transition-metadata`, { draftIds }, { timeout: 120000 })).data
}
export async function listExcelProductTypeDraftSelectionOptions(jobId, revisionId) {
  return (await http.get(`${base(jobId, revisionId)}/selection-options`)).data
}
export async function getExcelProductTypeDraftsBatch(jobId, revisionId, draftIds) {
  return (await http.post(`${base(jobId, revisionId)}/batch`, { draftIds }, { timeout: 120000 })).data
}
export async function generateExcelProductTypeDrafts(jobId, revisionId) {
  return (await http.post(`${base(jobId, revisionId)}/generate`, null, { timeout: 120000 })).data
}
export async function updateExcelProductTypeDraft(jobId, revisionId, draftId, payload) {
  return (await http.put(`${base(jobId, revisionId)}/${draftId}`, payload)).data
}
